export default __webpack_public_path__ + "static/media/KOD0008-min.b8631416.webp";